import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useSearchBarStylesNew = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'block'
    },
    action: {
      cursor: 'pointer'
    },
    inputSearch: {
      backgroundColor: '#FAFAFA',
      borderRadius: 13,
      '& .MuiOutlinedInput-inputMarginDense': {
        paddingTop: 22,
        paddingBottom: 22,
        border: 'none !important'
      }
    },
    noBorder: {
      border: 'none!important',
      boxShadow: '0px 4px 25px rgba(0, 0, 0, 0.1);',
      borderRadius: 13,
      [theme.breakpoints.down('xs')]: {
        boxShadow: 'none'
      }
    },
    dialogModal: {
      position: 'absolute',
      bottom: 'unset !important',
      left: 'unset !important',
      top: '124px !important',
      right: '0 !important',
      height: 'auto',
      width: '600px',
      overflow: 'hidden',
      padding: 0,
      backgroundColor: 'initial'
    },
    dialogContent: {
      backgroundColor: 'initial',
      padding: '25px 0px 0px 0px !important'
    }
  })
)
